import { Decimal } from 'decimal.js'

import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import asyncAction from 'modules/core/lib/asyncAction'

import type AllowanceIncidenceForm from 'modules/timeoff/lib/AllowanceIncidence'
import allowanceIncidences from 'modules/timeoff/store/collections/allowanceIncidences'
import type AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'

function buildDays(form: AllowanceIncidenceForm): number {
  const value = new Decimal(form.get('days_in_cents').value).mul(100).toNumber()

  const sign = Number(form.get('sign').value)

  if (sign === 1) return Math.abs(value)

  if (value < 0) return value

  return -value
}

interface Props {
  form: AllowanceIncidenceForm
  onSuccess: () => void
  incidence?: AllowanceIncidence
}
interface ReturnType {
  onSubmit: (closePortal: ClosePortalFn) => void
  submitting: boolean
}

const useUpsertIncidence = ({ form, incidence, onSuccess }: Props): ReturnType => {
  const { running: submitting, performAction: onSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      const payload = { ...form.data(), days_in_cents: buildDays(form) }

      const { success } = await asyncAction(() =>
        incidence ? incidence.save(payload) : allowanceIncidences.create(payload)
      )

      if (success) {
        onSuccess()
        closePortal()
      }
    },
    {
      successFlash: false,
    }
  )

  return {
    onSubmit,
    submitting,
  }
}

export default useUpsertIncidence
